import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';

interface ButtonProps {
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const AddButton = ({ onClick }: ButtonProps) => {
	const { t } = useTranslation();
	return (
		<Button variant="tetriary" onClick={onClick} type="button" className="px-0">
			{t('buttons.addField')}
		</Button>
	);
};

export const RemoveButton = ({ onClick }: ButtonProps) => {
	const { t } = useTranslation();
	return (
		<Button variant="link" onClick={onClick} type="button" className="text-red-600 px-2.5 self-end -translate-y-1" title={t('templates.deleteField')}>
			<Icon name="closeSmall" size={16} />
		</Button>
	);
}

const ButtonTemplates = {
	AddButton,
	RemoveButton,
};

export { ButtonTemplates };
